
import { Link, useNavigate } from 'react-router-dom'
import Header from '../../../common/header/Header'
import Footer from '../../../common/footer/Footer'
import { useEffect, useState } from 'react'
import { Get_Pooja_List_Category, Get_Pooja_Category_List } from '../../../../api/pooja/Pooja'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { Helmet } from 'react-helmet'
import { get_Page_Seo } from '../../../../api/global/Global'
import parse from 'html-react-parser';
import Loader from '../../../../loader/Loader'

const Allpoojacategory = () => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [all_Pooja_Category, set_All_Pooja_category] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;

    const validCategoryData = Array.isArray(all_Pooja_Category) ? all_Pooja_Category : [];
    const totalPages = Math.ceil(validCategoryData.length / productsPerPage);
    const [pageSeo, set_Page_Seo] = useState({})
    // Slice data for current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentCategory = validCategoryData.slice(startIndex, startIndex + productsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    useEffect(() => {
        const fetchPoojaCategory = async () => {
            setIsLoading(true);
            try {
                const token = User_Authentication();
                let response;

                if (!token) {
                    // No authentication
                    response = await Get_Pooja_Category_List();
                } else {
                    // Authenticated
                    response = await Get_Pooja_List_Category({ Authorization: `Bearer ${token}` });
                }

                const resData = response?.data || response?.response?.data;
                if (resData?.status == 200) {
                    set_All_Pooja_category(resData?.data?.pooja_category || []);
                } else {
                    console.warn("Unexpected response:", resData);
                }

            } catch (error) {
                console.error("Error fetching pooja list:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchPoojaCategory();
    }, []);

    useEffect(() => {
        const Get_Page_Seo = async () => {
            setIsLoading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "All Pooja Category")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                setIsLoading(false);
            }
        }
        Get_Page_Seo()
    }, [])

    return (
        <>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}all-pooja-category`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}all-pooja-category`} />
            </Helmet>
            {
                isLoading ? (
                    <Loader />
                ) : (<>
                    <Header />
                    <section className='banner-section'>
                        <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                            <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                            } className='w-full h-[300px]' />


                        </div>
                    </section>
                    <section className="gi-blog-section pt-8 max-[767px]:py-[30px] mb-20 inline-block w-full wow fadeInUp"
                        style={{ visibility: "visible", animationName: "fadeInUp" }}>
                        <div
                            className="mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="w-full mb-[-24px] px-3">
                                <div className="grid md:grid-cols-3 gap-3 items-center">
                                    <div className='title mb-5 col-span-2'>
                                        <h1 className='text-lg text-gray-900 font-bold'>All Pooja Category</h1>
                                        <div className='border-b-2 border-gray-900 w-[200px] mx-auto inline-block'></div>
                                    </div>

                                </div>
                                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4 inline-block'>

                                    {currentCategory?.length > 0 && currentCategory?.map((cate_result) => (
                                        <div className='p-4 rounded-xl shadow-custome scale-100 hover:scale-120 hover:shadow-2xl text-center cursor-pointer'>
                                            <div
                                                onClick={() => {
                                                    navigate(`/pooja/${cate_result?.slug}`
                                                    )
                                                }}>
                                                <img className='rounded-lg size-56 mx-auto' src={`${IMG_BASE_URL}${cate_result?.image}`} alt={cate_result?.image_alt} />
                                                <h4 className='text-gray-900 line-clamp-1 font-semibold text-[14px] mt-3'>{cate_result?.title}</h4>

                                            </div>

                                        </div>
                                    ))}


                                    {/* <div className='shadow-lg p-4 rounded-xl shadow-red-200/50 hover:shadow-cyan-100/50 text-center'>
                                <Link to="/book-pooja-list">
                                    <img className='rounded-lg size-56' src={Havans} alt='' />
                                    <h4 className='text-gray-900 line-clamp-1 font-semibold text-[14px] mt-3'>Havans</h4>
                                </Link>
                            </div>

                            <div className='shadow-lg p-4 rounded-xl shadow-red-200/50 hover:shadow-cyan-100/50 text-center'>
                                <Link to="/book-pooja-list" >
                                    <img className='rounded-lg size-56' src={Jaaps} alt='' />
                                    <h4 className='text-gray-900 line-clamp-1 font-semibold text-[14px] mt-3'>Jaaps</h4>
                                </Link>
                            </div>

                            <div className='shadow-lg p-4 rounded-xl shadow-red-200/50 hover:shadow-cyan-100/50 text-center'>
                                <Link to="/book-pooja-list" >
                                    <img className='rounded-lg size-56' src={BhajansChowki} alt='' />
                                    <h4 className='text-gray-900 line-clamp-1 font-semibold text-[14px] mt-3'>Bhajans & Chowki</h4>
                                </Link>
                            </div>

                            <div className='shadow-lg p-4 rounded-xl shadow-red-200/50 hover:shadow-cyan-100/50 text-center'>
                                <Link to="/book-pooja-list" >
                                    <img className='rounded-lg size-56' src={FestivalPooja} alt='' />
                                    <h4 className='text-gray-900 line-clamp-1 font-semibold text-[14px] mt-3'>Festival Pooja</h4>
                                </Link>
                            </div> */}
                                </div>

                                {/* Pagination Controls */}
                                <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                    <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, validCategoryData?.length)} of {all_Pooja_Category?.length} items</span>
                                    <ul className="gi-pro-pagination-inner flex">
                                        <li>
                                            <button onClick={handlePrev} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                Prev
                                            </button>
                                        </li>

                                        {[...Array(totalPages).keys()].map((page) => (
                                            <li key={page} className="inline-block float-left mr-[5px]">
                                                <button
                                                    onClick={() => handlePageChange(page + 1)}
                                                    className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                                                                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                                                                    text-[16px] justify-center items-center rounded-[5px]
                                                                     ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                >
                                                    {page + 1}
                                                </button>
                                            </li>
                                        ))}

                                        <li>
                                            <button onClick={handleNext} className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-red-600 leading-[30px] h-[32px] bg-red-500 flex flex text-center align-top text-[16px] justify-center items-center rounded-[5px]">
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                <div className="sub__title text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>

                            </div>

                        </div>

                    </section>
                    <div className="clearfixed float-left w-full inline-block"></div>

                    <Footer />
                </>)
            }

        </>
    );
}

export default Allpoojacategory